import { UserDetail } from '../../../components/User';
import { UserType } from '../../../types';

export function VendorUser() {
  return <UserDetail type={UserType.Vendor} />;
}
